import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MatPaginator} from '@angular/material/paginator';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../shared/services/auth.service';
import {startWith, takeUntil, tap} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';
import {HttpErrorResponse} from '@angular/common/http';
import {SoldPolicy} from '../../../shared/interface/sold-policy';
import {SoldPolicyService} from '../../../shared/services/sold-policy.service';

@Component({
  selector: 'app-all-policies-list',
  templateUrl: './all-policies-list.component.html',
  styleUrls: ['./all-policies-list.component.scss']
})
export class AllPoliciesListComponent implements AfterViewInit, OnDestroy {

  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  imports: SoldPolicy[] = [];
  displayedColumns: string[] = [
    'insuranceCompany', 'policyNumber', 'writtenPremium', 'concludeDate',
    'ofwca', 'partner', 'assetsRegional', 'contract', 'company',
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private soldPolicyService: SoldPolicyService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.soldPolicyService.policyListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<SoldPolicy>) => {
          this.imports = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        startWith(''),
        takeUntil(this.destroyed$)
      ).subscribe(() => this.loadListData());
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.soldPolicyService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.filtersForm.value);
  }

  filter(): void {
    if (this.paginator.pageIndex === 0) {
      this.loadListData();
    } else {
      this.paginator.firstPage();
    }
  }

  downloadReport(): void {
    this.soldPolicyService.downloadReport(this.filtersForm.value)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.loadListData();
  }

}
